import classNames from "classnames";
import { getPlayerHeightInFeetAndInches } from "rivals/shared/utils/height";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const { nflDraftEligible, philter } = strings;

const Stats = ({
  collegeExperience,
  collegeName,
  draftStatus,
  height,
  positionName,
  variant,
  weight
}: OwnProps): JSX.Element => {
  const playerWeight = `${weight ? weight : "-"} lbs`;
  const playerHeight = height ? getPlayerHeightInFeetAndInches(height) : "-";
  // Possible classNames include 'cardVariant' or 'pageVariant'
  const containerClassNames = classNames(styles.personalStats, {
    [styles[`${variant}Variant`]]: variant
  });

  return (
    <div className={containerClassNames} {...setData("athlete-profile-stats")}>
      <div className={styles.personalStatRow}>
        <span className={styles.positionName} {...setData(philter, "position")}>
          {positionName}
        </span>
        <span className={styles.point}>{"•"}</span>
        <div className={styles.heightWeight}>
          <span {...setData(philter, "height")}>{playerHeight}</span>
          <span className={styles.column}> | </span>
          <span {...setData(philter, "weight")}>{playerWeight}</span>
        </div>
      </div>
      <div className={styles.personalStatRow}>
        {collegeExperience && (
          <span {...setData(philter, "exp-level")}>{collegeExperience} @ </span>
        )}
        <span {...setData(philter, "college-name")}>{collegeName}</span>
      </div>
      {draftStatus && (
        <div className={styles.personalStatRow}>
          <span {...setData(philter, "draft-status")}>{nflDraftEligible}</span>
        </div>
      )}
    </div>
  );
};

export default Stats;
